import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ReactComponent as Mice } from '../../img/common/mice.svg';
import { ReactComponent as MuteMice } from '../../img/common/muteMice.svg';
import { selectVoiceCall, setMute } from '../../slice/voiceCallSlice';

type MuteMyVoiceButtonProps = {
    height: number;
    width: number;
    groupId: number;
    roomId: number;
    muteColor: string;
};
export const MuteMyVoiceButton: React.FC<MuteMyVoiceButtonProps> = (props) => {
    const dispatch = useDispatch();
    const { myVoice } = useSelector(selectVoiceCall);
    const muteHandler = async (val: boolean) => {
        dispatch(
            setMute({
                groupId: props.groupId,
                roomId: props.roomId,
                isMute: val,
            })
        );
    };

    return (
        <>
            {myVoice.isMute ? (
                <MuteMice
                    height={props.height}
                    width={props.width}
                    role="img"
                    aria-label="ミュートを外す"
                    fill={props.muteColor}
                    style={{ cursor: 'pointer' }}
                    onClick={() => muteHandler(false)}
                />
            ) : (
                <Mice
                    height={props.height}
                    width={props.width}
                    fill="#F14D38"
                    role="img"
                    aria-label="ミュートする"
                    style={{ cursor: 'pointer' }}
                    onClick={() => muteHandler(true)}
                />
            )}
        </>
    );
};
